import { render, staticRenderFns } from "./telephone.vue?vue&type=template&id=2c1d28cf&scoped=true"
import script from "./telephone.vue?vue&type=script&lang=js"
export * from "./telephone.vue?vue&type=script&lang=js"
import style0 from "./telephone.vue?vue&type=style&index=0&id=2c1d28cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d28cf",
  null
  
)

export default component.exports